module.exports = __webpack_public_path__ + "img/fisher.5f186547.png";